import React, { useState, useEffect, useCallback } from "react";
import { InputNumber } from 'primereact/inputnumber';
import { ToggleButton } from 'primereact/togglebutton';
import { Divider } from 'primereact/divider';
import moment from "moment";
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { useSelector } from 'react-redux';
import { dateTimeFormat } from '../../../utils/mics';

const ReminderRecurrenceForm = (props) => {
    const { visible, handleReminderRecurrence, taskDateTime, dueDateTime, recurrenceInfo, handleCancelReminderRecurrence } = props;
    const [startDateTime, setStartDateTime] = useState(taskDateTime ? taskDateTime : new Date());
    const [repeatType, setRepeatType] = useState('Weekly');
    const [repeatEvery, setRepeatEvery] = useState(1.0);
    const [selectedDays, setSelectedDays] = useState([true, true, true, true, true, true, true]);
    const [endDate, setEndDate] = useState(dueDateTime ? dueDateTime : new Date());
    const [endMinDate, setEndMinDate] = useState(null);
    const [repeatEveryError, setRepeatEveryError] = useState('');
    const [maxHourly, setMaxHourly] = useState(24);

    // const repeatOptions = useMemo(() => [
    //     { label: 'Daily', value: 'Daily' },
    //     { label: 'Weekly', value: 'Weekly' }
    // ], []);
    const repeatOptions = useSelector((state) => state.common.repeatList);
    const currentDateTime = new Date();
    currentDateTime.setDate(currentDateTime.getDate() - 1);

    const handleDaySelect = (index) => {
        setSelectedDays((prevDays) => {
            const updatedDays = [...prevDays];
            updatedDays[index] = !updatedDays[index];
            return updatedDays;
        });
    };

    const getRepeatDays = useCallback(() => {
        return selectedDays
            .map((day, index) => (day ? (index === 0 ? 7 : index) : null))
            .filter((day) => day !== null)
            .join(',');
    }, [selectedDays]);

    const handleRepeatChange = (e) => {
        const value = e.value;
        setRepeatType(value);
        if(value === 'Hourly') {
            const strTaskDate = moment(taskDateTime).format('DD-MM-YYYY');
            setStartDateTime(moment(taskDateTime, dateTimeFormat).toDate());
            const newEndMinDate = moment(strTaskDate + ' 23:59', dateTimeFormat).toDate();
            if(moment(dueDateTime).isBefore(newEndMinDate)) {
                const time1 = moment(taskDateTime);
                const time2 = moment(dueDateTime);
                const diffInHours = time2.diff(time1, 'hours');
                
                setMaxHourly(diffInHours);
                setEndMinDate(dueDateTime);
                setEndDate(dueDateTime);
            }
            else{
                const time1 = moment(taskDateTime);
                const time2 = moment(newEndMinDate);
                const diffInHours = time2.diff(time1, 'hours');
                
                setMaxHourly(diffInHours);
                setEndMinDate(newEndMinDate);
                setEndDate(newEndMinDate);
            }
        }
        setRepeatEvery(1.0);
    }

    const handleCancel = () => {
        visible(false);
        handleCancelReminderRecurrence();
    }

    const handleSubmit = () => {
        
        if(repeatEvery <= 0) {
            setRepeatEveryError('Every value should not be less or equal to 0');
            return;
        }
        visible(false);

        let finalEndDate = moment(endDate).format(dateTimeFormat);

        // if(repeatType === 'Hourly') {
        //     const strTaskDate = moment(taskDateTime).format('DD-MM-YYYY');
        //     const newEndMinDate = moment(strTaskDate + ' 23:59', dateTimeFormat).toDate();
        //     finalEndDate = moment(newEndMinDate).format(dateTimeFormat);
        // }
        const recurrenceDetails = {
            startDateTime: moment(startDateTime).format(dateTimeFormat),
            repeatBy: repeatType,
            repeatEvery: repeatEvery,
            repeatDays: repeatType === 'Weekly' ? getRepeatDays() : repeatType === 'Monthly'? moment(startDateTime).format('DD') : '',
            endDateTime: finalEndDate,
            status: 'Active'
        };
        handleReminderRecurrence(recurrenceDetails);
    };

    useEffect(() => {
        if (recurrenceInfo) {
            if(recurrenceInfo.repeatDays || recurrenceInfo.repeatDays === '') {
                const previousSelectedDays = recurrenceInfo.repeatDays.split(',');
                const updatedDays = [...selectedDays];
                for(let i = 0; i < updatedDays.length; i++) {
                    updatedDays[i] = false;

                }

                for(let k = 0; k < previousSelectedDays.length; k++){
                    let index = previousSelectedDays[k];
                    if(index === 7)
                    {
                        updatedDays[0] = !updatedDays[0]; 
                    }
                    else {
                        updatedDays[index] = !updatedDays[index];
                    }
                }
                setSelectedDays(updatedDays);
            }
            
            if(recurrenceInfo.repeatBy) {
                setRepeatType(recurrenceInfo.repeatBy);
            }
            if(recurrenceInfo.repeatEvery) {
                setRepeatEvery(recurrenceInfo.repeatEvery);
            }

            
            if(recurrenceInfo.startDateTime) {
                const duration = repeatType === 'Daily' ? 'days' : repeatType === 'Weekly' ? 'weeks' : repeatType === 'Monthly' ? 'months' : repeatType === 'Years' ? 'years' : 'hours';
                setStartDateTime(moment(recurrenceInfo.startDateTime, dateTimeFormat).toDate());
                if(recurrenceInfo.endDateTime) {
                    const endDT = moment(recurrenceInfo.endDateTime, dateTimeFormat).toDate();
                    setEndMinDate(endDT);
                    setEndDate(endDT);
                }
                else {
                    const newEndMinDate = moment(recurrenceInfo.startDateTime, dateTimeFormat).add(recurrenceInfo.repeatEvery, duration).toDate();
                    setEndMinDate(newEndMinDate);
                    setEndDate(newEndMinDate);
                }
            }
            else if(taskDateTime) {
                const duration = repeatType === 'Daily' ? 'days' : repeatType === 'Weekly' ? 'weeks' : repeatType === 'Monthly' ? 'months' : repeatType === 'Years' ? 'years' : 'hours';
                setStartDateTime(taskDateTime);
                const newEndMinDate = moment(taskDateTime, dateTimeFormat).add(recurrenceInfo.repeatEvery, duration).toDate();
                setEndMinDate(newEndMinDate);
                setEndDate(newEndMinDate);
            }
        }
    }, [recurrenceInfo, repeatType, selectedDays, taskDateTime]);

    useEffect(() => {
        const duration = repeatType === 'Daily' ? 'days' :
            repeatType === 'Weekly' ? 'weeks' :
            repeatType === 'Monthly' ? 'months' :
            repeatType === 'Years' ? 'years' : 'hours';
        const newEndMinDate = moment(startDateTime, dateTimeFormat).add(repeatEvery, duration).toDate();
        setEndMinDate(newEndMinDate);
        console.log(endMinDate);
    }, [startDateTime, repeatEvery, repeatType, endMinDate]);

    return (
        <div className="p-fluid p-formgrid p-grid">
            <div className="field col-12">
                <label htmlFor="start">Start</label>
                <Calendar
                    className="w-full"
                    id="start"
                    value={startDateTime}
                    onChange={(e) => setStartDateTime(e.value)}
                    dateFormat="dd/mm/yy"
                    showTime={true} // Enable time selection
                    hourFormat="12" // Optional: specify the time format (12 or 24 hour)
                    disabled={repeatType === 'Hourly'}
                    minDate={currentDateTime}
                    maxDate={dueDateTime}
                />
            </div>

            <div className="field col-12">
                <label htmlFor="repeat">Repeat</label>
                <Dropdown
                    id="repeat"
                    value={repeatType}
                    options={repeatOptions}
                    onChange={(e) => handleRepeatChange(e)}
                />
            </div>

            <div className="field col-12">
                <label htmlFor="repeatEvery">Every {repeatType}</label>
                {repeatType === 'Hourly' && <InputNumber
                    id="repeatEvery"
                    value={repeatEvery}
                    mode="decimal"
                    onChange={(e) => setRepeatEvery(e.value)}
                    minFractionDigits={1}
                    maxFractionDigits={1}
                    max={maxHourly}
                    suffix={' hour(s)'}
                />}
                {repeatType !== 'Hourly' && <InputNumber
                    id="repeatEvery"
                    value={repeatEvery}
                    onChange={(e) => setRepeatEvery(e.value)}
                    min={1}
                    suffix={repeatType === 'Daily' ? ' day(s)' : 
                        repeatType === 'Weekly' ? ' week(s)' : 
                        repeatType === 'Monthly' ? ' month(s)' : 
                        ' year(s)'}
                />}
                {repeatEveryError && 
                    <small className="p-error">{repeatEveryError}</small>
                }
            </div>

            {repeatType === 'Weekly' && (
                <div className="field col-12">
                    <label>On</label>
                    <div className="flex theme-basic">
                        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, index) => (
                            <ToggleButton
                                className="mr-1"
                                key={index}
                                onLabel={day}
                                offLabel={day}
                                checked={selectedDays[index]}
                                onChange={() => handleDaySelect(index)}
                                style={{ width: '2.5rem', marginRight: '0.5rem' }}
                            />
                        ))}
                    </div>
                </div>
            )}

            <Divider />

            <div className="field col-12">
                <label htmlFor="end">End</label>
                <Calendar
                    id="end"
                    value={endDate}
                    onChange={(e) => setEndDate(e.value)}
                    dateFormat="dd/mm/yy"
                    showTime={true} // Enable time selection
                    hourFormat="12" // Optional: specify the time format (12 or 24 hour)
                    // minDate={endMinDate}
                    maxDate={dueDateTime}
                    disabled={repeatType === 'Hourly'}
                />
            </div>

            <div className="field col-12 p-text-center flex justify-center">
                <Button
                    label="Cancel"
                    className="p-button-secondary mr-2"
                    onClick={() => handleCancel()}
                />
                <Button label="Save" severity="basic" onClick={handleSubmit} />
            </div>
        </div>
    );
};

export default ReminderRecurrenceForm;
